import {Outlet, Link} from "react-router-dom";

const Layout = () => {
    return (
        <>
            <ul>
                <li>
                    <Link to="/">Home</Link>
                </li>
                <li>
                    <Link to="/about">About</Link>
                </li>
                <li>
                    <Link to="/contact">Contact</Link>
                </li>
                <li>
                    <Link to="/projects">Projects</Link>
                    <ul>
                        <li>
                            <Link to="/mumble-generator">Mumble Generator</Link>
                        </li>
                        <li>
                            <Link to="/damp-ghosts">Where the Ghosts Are Damp</Link>
                        </li>
                    </ul>
                </li>
            </ul>
            <Outlet/>
        </>
    )
};

export default Layout;
